
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import CrmStatus from "@/models/crm/crm-status";
import {CrmService, UserConfigService} from "@/services";
import { CrmSettings } from "@/models/user-configs/crm-settings";
import AppCrmCalendarFieldsSettings from "@/components/crm/CrmCalendarFieldsSettings.vue";

export default Vue.extend({
	data() {
		return {
			toEditStatus: null as null | CrmStatus,
			statuses: [] as CrmStatus[],
			crmSettings: UserConfigService.getCrmSettings() as CrmSettings,
		};
	},
	computed: {
		path():IBreadCrumb[] {
			return [{
				to: "/settings", value: this.$ct("general")
			},      {value: this.$ct("crm")}] as IBreadCrumb[];
		},
		modalTitle():string {
			if (!this.toEditStatus) {
				return "";
			}
			if (this.toEditStatus.ID == 0) {
				return this.$ct("modal-title-crm-new").toString();
			}
			return this.$ct("modal-title-crm-edit").toString();
		},
	},
	methods: {
		onSorted(){
			this.statuses.forEach((r,i)=>{
				r.Position = i;
			});
			CrmService.putCrmStatuses(this.statuses);
		},
		async fetch() {
			this.statuses = await CrmService.getCrmStatuses();
		},
		openNewModal() {
			this.toEditStatus = new CrmStatus({Position: this.statuses.length+1});
		},
		cancelModal() {
			this.toEditStatus = null;
		},
		editStatus(value:CrmStatus) {
			this.toEditStatus = value;
		},
		async deleteStatus(value:CrmStatus) {
			let confirmText = this.$ct("common.confirmDelete").toString();
			let confirm = await this.$confirmBuilder(confirmText).setWarningTitle().show();
			if (!confirm) {
				return;
			}
			await CrmService.deleteCrmStatus(value.ID);
			await this.fetch();
		},
		async save(){
			if(!this.toEditStatus)
				return;

			if(this.toEditStatus?.ID){
				await CrmService.putCrmStatus(this.toEditStatus);
			}else{
				await CrmService.postCrmStatus(this.toEditStatus);
				await this.fetch();
			}
			this.cancelModal();
		},
		async saveCrmSettings(){
			this.crmSettings = await UserConfigService.setCrmSettings(this.crmSettings);
		}
	},
	async mounted() {
		await this.fetch();
	},
	components: {
		AppCrmCalendarFieldsSettings
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
